import { Outlet } from "react-router-dom";
import { Sidebar } from "@/widgets/sidebar/Sidebar";
import { Header } from "@/widgets/header/Header";
import { useIsMobile } from "@/shared/hooks/use-mobile";

export function AdminLayout() {
  const isMobile = useIsMobile();

  return (
    <div className="flex h-screen overflow-hidden">
      {!isMobile && <Sidebar />}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto bg-background p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
